import { Button, Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridContainerStyled = styling(Grid)((props) => ({
  width: "100%",
  display: "flex",
  height: "190px",
  alignItems: "center",
  padding: "32px 40px",
  justifyContent: "space-between",
  alignSelf: "stretch",
  background:
    "linear-gradient(91deg, rgba(255, 255, 255, 0.20) -4.38%, rgba(81, 42, 204, 0.20) 53.58%, rgba(255, 255, 255, 0.20) 113.82%)",

  [props.theme.breakpoints.down("lg")]: {
    padding: "32px 40px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "32px 16px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "24px",
  },
}));

export const CardListContainer = styling(Grid)((props) => ({
  display: "flex",
  width: "100%",
  maxWidth: "1280px",
  justifyContent: "space-between",
  alignItems: "center",
  margin: "auto",

  [props.theme.breakpoints.down("lg")]: {
    flexDirection: "row",
    alignItems: "center",
    gap: "24px",
    alignSelf: "stretch",
    margin: "auto",
    textAlign: "left",
  },

  [props.theme.breakpoints.down("tablet")]: {
    textAlign: "left",
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "24px",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    flexDirection: "column",
  },
}));

export const CardText = styling(Typography)((props) => ({
  color: "#40249B",
  fontFamily: props.type == "desc" ? "Inter" : "Inter",
  fontSize: props.type == "desc" ? "20px" : "40px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: props.type == "desc" ? "30px" : "48px",
  alignSelf: "stretch",
  letterSpacing: props.type == "desc" ? "0.03px" : "0.06px",
  textAlign: "left",

  [props.theme.breakpoints.down("md")]: {
    maxWidth: "434px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props.type == "desc" ? "16px" : "24px",
    lineHeight: props.type == "desc" ? "22.4px" : "28.8px",
    letterSpacing: props.type == "desc" ? "unset" : "0.036px",
    maxWidth: "unset",
  },
}));

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  minWidth: "240px",
  width: "fit-content",
  padding: "12px 24px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  textTransform: "capitalize",
  border: "1px solid #F1CC44",
  background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
  boxShadow: "0 2px 4px 0 rgba(104, 77, 0, 0.40)",
  color: "rgba(0, 0, 0, 0.87)",
  textAlign: "center",
  borderRadius: "10px",
  height: "54px",
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "30px",
  letterSpacing: "0.1px",

  ":hover": {
    background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
    fontWeight: 700,
  },

  [props.theme.breakpoints.down("lg")]: {
    minWidth: "220px",
    height: "48px",
    padding: "12px 24px",
    fontSize: "16px",
    lineHeight: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));
